import Icon from '../components/Icon.vue'

Icon.register({"paint-brush":{"width":1792,"height":1792,"paths":[{"d":"M1615 0q70 0 122.5 46.5t52.5 116.5q0 63-45 151-332 629-465 752-97 91-218 91-126 0-216.5-92.5t-90.5-219.5q0-128 92-212l638-579q59-54 130-54zM706 1034q39 76 106.5 130t150.5 76l1 71q4 213-129.5 347t-348.5 134q-123 0-218-46.5t-152.5-127.5-86.5-183-29-220q7 5 41 30t62 44.5 59 36.5 46 17q41 0 55-37 25-66 57.5-112.5t69.5-76 88-47.5 103-25.5 125-10.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paint-brush.js
// module id = 1601
// module chunks = 0